export default __webpack_public_path__ + "static/media/jCole.b5221c1b.jpeg";